<template>
  <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
    <template slot="lastHeaderColumns" slot-scope="props">
      <grid-table-th
        v-if="props.magicalMenuCodes.includes('task-record')"
        width="80px"
      >任务记录
      </grid-table-th>
      <grid-table-th
        v-if="props.magicalMenuCodes.includes('send-record')"
        width="80px"
      >发送记录
      </grid-table-th>
    </template>
    <template slot="lastBodyColumns" slot-scope="props">
      <grid-table-td
        v-if="props.magicalMenuCodes.includes('task-record')"
        @click.native="handle(props.row, 'task')"
        width="80px"
      >查看
      </grid-table-td>
      <grid-table-td
        v-if="props.magicalMenuCodes.includes('send-record')"
        @click.native="handle(props.row, 'send')"
        width="80px"
      >查看
      </grid-table-td>
    </template>
  </grid>
</template>
<script>
import Grid from '../../../components/grid/grid.vue'
import GridTableTh from '../../../components/grid-menu/grid-table-th'
import GridTableTd from '../../../components/grid-menu/grid-table-td'
import GridTopMenu from '../../../components/grid-menu/grid-top-menu'
import util from '../../../libs/util'

export default {
  components: {
    GridTopMenu,
    GridTableTd,
    GridTableTh,
    Grid
  },
  name: 'service-usage-record',
  data() {
    return {
      gridConfigUrl: ''
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
  },
  methods: {
    handle(data, type) {
      let routerName = ''
      if (type === 'task' && data.isSupportTaskRecord === true) {
        routerName = data.taskRouterName
      } else if (type === 'send' && data.isSupportSendRecord === true) {
        routerName = data.sendRouterName
      } else {
        this.$notify.error({title: data.specificServiceName, message: data.errMsg})
        return
      }
      util.changeRouter(this, {
        name: routerName
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/custom/components/grid/service-usage-record.vue